import { AuthContext } from "@src/AuthProvider";
import React, { useContext } from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { largeSize } from "@src/utils/screensize-helper";
import { useNavigation } from "@react-navigation/native";
import useStyles from "./styles.css";
import images from "@assets/images";
import colors from "@assets/colors";
import Icon from "@assets/svg";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectAuthLoggedIn } from "@src/ducks/slices/auth.slice";
import SVGIcon from "@assets/svg";

type Props = {
  onBack?: () => void;
}

const Header = ({ onBack }: Props) => {
  const styles = useStyles();
  const isLargeSize = largeSize();
  const navigation = useNavigation<any>();
  const isLoggedIn = useAppSelector(selectAuthLoggedIn);
  const { maintenance } = useContext(AuthContext);
  
   const size = React.useMemo(() => {
      if(isLargeSize){
        return { logo: {
          width: 42,
          height: 60,
        }, signsecure: {
          width: 185,
          height: 61.5,
        }
        };
      }
  
      return { logo: {
        width: 42,
        height: 60,
      }, signsecure: {
        width: 180,
        height: 42,
      }
      };
    },[isLargeSize]);

  const onGoBack = () => {
    if (onBack) {
      return onBack();
    }
    if (maintenance) {
      navigation.goBack()
      return
    }
    navigation.navigate(isLoggedIn ? "Home" : "Signin");
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={onGoBack}
        activeOpacity={0.9}
        style={styles.btn_style}
      >
        <Icon name="back" fill={colors.white} />
        <Text style={styles.t_back}>Back</Text>
      </TouchableOpacity>
      <SVGIcon name="power-by-odoo" {...size.signsecure} /> 
    </View>
  );
};

export default Header;
